//@ts-nocheck
import React, { useState } from 'react'

import classNames from 'classnames'
import {
  Body,
  Button,
  CloudinaryImage,
  Form,
  Spacer,
  ZipInput,
} from 'ethos-design-system'
import { ANALYTICS_SERVICE_KEYS } from 'lib/@getethos/analytics/constants'
import { getStateFromGoogleApi, useGoogleMaps } from 'lib/GoogleMapsApi/utils'
import PropTypes from 'prop-types'
import qs from 'qs'
import { v4 as uuidv4 } from 'uuid'

import useSiteAppUrl from '@/hooks/useSiteAppUrl'

import { cmsModuleAnalytics } from '../../../lib/@getethos/analytics/analyticsEvents'
import { BUTTONS, MODULES } from '../../../lib/@getethos/analytics/constants'
import { appRoute, navigateToApp } from '../../../lib/@getethos/urls/urls'
import Markdown, { MARKDOWN_NODE_RESTRICTION_SETS } from '../global/Markdown'
import VideoEmbed from '../global/VideoEmbed'
import backgroundStyles from '../styles/background-color.module.scss'
import headerStyles from './Header.module.scss'
import versatileStyles from './HeaderVersatile.module.scss'

export const HeaderVersatileTemplate = ({
  groupImage,
  imageAlt,
  heading,
  backupHeading,
  enableH1,
  headingSize,
  hideMediaMobile,
  displaySubHeading,
  subHeading,
  ctaLabel,
  displayCta,
  clickthroughUrl,
  ctaLabel2,
  displayCta2,
  clickthroughUrl2,
  backgroundColor,
  mediaType,
  mediaTitle,
  youtubeId,
  zipcodeField,
  zipcodeFieldLabel,
  zipcodeCtaLabel,
  mobileCtaPosition,
  ctaColor,
  ctaColor2,
  useNewFonts,
}) => {
  let cta, cta2, phoneCta, tabletAndUpCta, phoneCta2, tabletAndUpCta2

  let utmSource = 'none'
  if (typeof window !== 'undefined') {
    const urlSearchParams = new URLSearchParams(window.location.search)
    if (urlSearchParams.has('utm_source')) {
      utmSource = urlSearchParams.get('utm_source')
    }
  }

  const [zipInputError, setZipInputError] = useState('')
  const [regionState, setRegionState] = useState({})

  const siteAppUrl = useSiteAppUrl()
  if (!siteAppUrl) {
    throw new TypeError('siteAppUrl is undefined')
  }

  /**
   * @param heading
   * @returns {string} heading to be rendered on the page
   */
  const parseHeading = (heading) => {
    if (typeof window === 'undefined') {
      return heading
    }

    let ret = heading

    if (ret.includes('ETHOS_FIRST_NAME') && location.search) {
      const { name } = qs.parse(location.search.slice(1))
      ret = name ? ret.replace('ETHOS_FIRST_NAME', name) : backupHeading
    }

    // replace one phone number with a clickable link
    // matches phone numbers formatted as 1-555-555-5555 or 1 (555) 555-5555
    const phoneRE = /1-(\d+)-(\d+)-(\d+)|1 \((\d+)\) (\d+)-(\d+)/

    const matches = ret.match(phoneRE)

    if (matches && matches.length >= 4) {
      const [readablePhone, area, prefix, last4] = matches.filter((el) => el)
      const link = `[${readablePhone}](tel:+1${area + prefix + last4})`
      ret = ret.replace(readablePhone, link)
    }

    return ret
  }

  const CTAButtonVariation =
    ctaColor === 'darkSalamander'
      ? Button.Medium.DarkSalamander
      : ctaColor === 'salamander'
      ? Button.Medium.Salamander
      : displayCta2
      ? Button.Medium.Black
      : Button.Medium.BlackOutline

  const mainHeading = parseHeading(heading)

  const eventId = uuidv4()

  if (displayCta) {
    const ctaButton = <CTAButtonVariation>{ctaLabel}</CTAButtonVariation>

    phoneCta = <div className={headerStyles.PhoneOnly}>{ctaButton}</div>
    tabletAndUpCta = <div className={headerStyles.TabletAndUp}>{ctaButton}</div>
    cta = (
      <Body.Regular400>
        <a
          href={clickthroughUrl}
          onClick={() => {
            cmsModuleAnalytics.ctaClicked({
              properties: {
                module: MODULES.HEADER_VERSATILE,
                ctaLabel: BUTTONS.GET_QUOTE,
                clickthroughUrl: clickthroughUrl,
                utmSource: utmSource,
              },
              sendServiceEvent: false,
              eventId,
            })
          }}
          data-properties={JSON.stringify({
            key: ANALYTICS_SERVICE_KEYS.CTA,
            label: BUTTONS.GET_QUOTE,
            target: clickthroughUrl,
            region: MODULES.HEADER_VERSATILE,
            eventId,
          })}
        >
          {phoneCta}
          {tabletAndUpCta}
        </a>
      </Body.Regular400>
    )
  }

  const eventId2 = uuidv4()
  if (displayCta2) {
    const CTAButtonVariation2 =
      ctaColor2 === 'darkSalamander'
        ? Button.Medium.DarkSalamander
        : ctaColor2 === 'salamander'
        ? Button.Medium.Salamander
        : Button.Medium.BlackOutline

    phoneCta2 = (
      <div className={headerStyles.PhoneOnly}>
        <CTAButtonVariation2>{ctaLabel2}</CTAButtonVariation2>
      </div>
    )
    tabletAndUpCta2 = (
      <div className={headerStyles.TabletAndUp}>
        <CTAButtonVariation2>{ctaLabel2}</CTAButtonVariation2>
      </div>
    )
    cta2 = (
      <Body.Regular400>
        <a
          href={clickthroughUrl2}
          onClick={() => {
            cmsModuleAnalytics.ctaClicked({
              properties: {
                module: MODULES.HEADER_VERSATILE,
                ctaLabel: BUTTONS.START_APPLYING,
                clickthroughUrl: clickthroughUrl,
                utmSource: utmSource,
              },
              sendServiceEvent: false,
              eventId: eventId2,
            })
          }}
          data-properties={JSON.stringify({
            key: ANALYTICS_SERVICE_KEYS.CTA,
            label: BUTTONS.START_APPLYING,
            target: clickthroughUrl,
            region: MODULES.HEADER_VERSATILE,
            eventId: eventId2,
          })}
        >
          {phoneCta2}
          {tabletAndUpCta2}
        </a>
      </Body.Regular400>
    )
  }

  const hasCta = displayCta && cta
  const hasCta2 = displayCta2 && cta2

  const headingElement = enableH1 ? 'h1' : 'div'

  const markdownElement = (
    <Markdown
      input={mainHeading}
      allowedMarkdownTypes={MARKDOWN_NODE_RESTRICTION_SETS.LINK_ONLY}
    />
  )

  const isImage = groupImage && groupImage.length > 0 && mediaType !== 'video'
  const isVideo = youtubeId && youtubeId.length > 0 && mediaType === 'video'
  const noMedia = !isImage && !isVideo

  const mediaClasses = [
    headerStyles.Header__Column,
    versatileStyles.Header__Column,
  ]

  const headerClassNames = [
    versatileStyles.Header__Column,
    versatileStyles.Header__ColumnText,
  ]

  if (noMedia) {
    headerClassNames.push(versatileStyles.NoMedia)
  }

  if (hideMediaMobile) {
    mediaClasses.push(headerStyles.hideMediaMobile)
  }

  const headerInnerClassNames = [
    versatileStyles.Header__Inner,
    isVideo
      ? versatileStyles.HeaderVersatile__Video
      : versatileStyles.HeaderVersatile__Image,
  ]

  const showZipcodeField = zipcodeField && zipcodeCtaLabel

  const zipValidator = () => {
    if (zipInputError) {
      setZipInputError('')
    }

    return ''
  }

  const fetchStateFromZipCallback = async (zipcode) => {
    // Check to see if Region has already been fetched
    if (regionState[zipcode]) {
      return regionState[zipcode]
    }

    // Fetch the state from the Google Maps API
    const stateFromZip = await getStateFromGoogleApi(
      zipcode,
      cmsModuleAnalytics
    )

    // Put region into state to prevent a second call
    setRegionState((regionState) => ({
      ...regionState,
      [zipcode]: stateFromZip,
    }))

    return stateFromZip
  }

  const handleZipSubmit = async ({ zipcode }) => {
    const region = await fetchStateFromZipCallback(zipcode)
    if (region === 'NY') {
      setZipInputError(
        "Sorry, it looks like you entered a zip code from a state we don't operate in. We're working on it, so check back soon!"
      )
      return
    }

    cmsModuleAnalytics.ctaClicked({
      properties: {
        module: MODULES.HEADER_VERSATILE,
        ctaLabel: BUTTONS.GET_QUOTE,
      },
    })

    navigateToApp(appRoute.term(siteAppUrl), {
      zipCode: zipcode,
    })
  }

  const fields = {
    zipcode: {
      component: (props) => {
        return (
          <ZipInput
            {...props}
            placeholder="Zip code"
            validator={zipValidator}
          />
        )
      },
      tid: 'zip-input',
    },
  }
  const config = {
    formName: 'zip-form',
    fields,
    onSubmit: handleZipSubmit,
    autocompleteOff: true,
  }

  const ZipcodeCTA = () => {
    useGoogleMaps()
    return (
      <React.Fragment>
        {zipcodeFieldLabel && (
          <span className={versatileStyles.zipcodeFieldLabel}>
            {zipcodeFieldLabel}
          </span>
        )}
        <Form config={config}>
          {({ field }) => {
            return (
              <div className={versatileStyles.zip}>
                <div className={versatileStyles.zipInput}>
                  {field('zipcode')}
                </div>
                <div className={versatileStyles.zipSubmit}>
                  <Button.Medium.Black data-tid={'submit-zip'} type="submit">
                    {zipcodeCtaLabel}
                  </Button.Medium.Black>
                </div>
              </div>
            )
          }}
        </Form>
        {zipInputError}
      </React.Fragment>
    )
  }

  const ctaSectionStyles = [versatileStyles.ctas]

  if (mobileCtaPosition === 'center') {
    ctaSectionStyles.push(versatileStyles.center)
  }

  const ctaSection = showZipcodeField ? (
    <ZipcodeCTA />
  ) : (
    <div
      className={classNames(ctaSectionStyles.join(' '), {
        [versatileStyles.newFonts]: useNewFonts,
      })}
    >
      {hasCta && <React.Fragment>{cta}</React.Fragment>}
      {hasCta && hasCta2 && (
        <div className={headerStyles.PhoneOnly}>
          <Spacer.H16 />
        </div>
      )}
      {displayCta2 && cta2 && <React.Fragment>{cta2}</React.Fragment>}
    </div>
  )

  const headerContent = (
    <div
      className={[
        versatileStyles.Header,
        headerStyles.Header,
        versatileStyles.HeaderVersatile,
      ].join(' ')}
    >
      <div className={headerInnerClassNames.join(' ')}>
        <div className={headerClassNames.join(' ')}>
          {heading &&
            headingSize === 'large' &&
            React.createElement(
              headingElement,
              {
                className: useNewFonts
                  ? 'new-display-m'
                  : 'old-title-large-500',
              },
              markdownElement
            )}
          {heading && headingSize === 'xlarge' && (
            <React.Fragment>
              {React.createElement(
                headingElement,
                {
                  className: useNewFonts
                    ? 'new-display-l'
                    : 'old-title-xlarge-500',
                },
                markdownElement
              )}
              <Spacer.H8 />
            </React.Fragment>
          )}
          <Spacer.H16 />
          {displaySubHeading && (
            <div className={versatileStyles.Header__SubHeading}>
              <div
                className={classNames(versatileStyles.subHeadingText, {
                  [versatileStyles.newFonts]: useNewFonts,
                })}
              >
                <Markdown
                  input={subHeading}
                  allowedMarkdownTypes={
                    MARKDOWN_NODE_RESTRICTION_SETS.LINK_ONLY
                  }
                />
              </div>
              {(hasCta || hasCta2) && <Spacer.H32 />}
            </div>
          )}
          {ctaSection}
        </div>
        {isImage && (
          <div className={mediaClasses.join(' ')}>
            <figure>
              <CloudinaryImage
                width={[375, 384, 720, 720]}
                height={[250, 480, 720, 480]}
                publicId={groupImage}
                alt={imageAlt}
              />
            </figure>
          </div>
        )}
        {isVideo && (
          <div className={mediaClasses.join(' ')}>
            <VideoEmbed youtubeId={youtubeId} videoTitle={mediaTitle} />
          </div>
        )}
        {noMedia && <div className={headerStyles.Header__Column} />}
      </div>
    </div>
  )

  const CapitalizedBackgroundColor =
    backgroundColor.charAt(0).toUpperCase() + backgroundColor.slice(1)

  const StyleClasses = [
    headerStyles.Header__Wrapper,
    backgroundStyles[`bg${CapitalizedBackgroundColor}`],
  ]

  return (
    <React.Fragment>
      <div className={StyleClasses.join(' ')}>{headerContent}</div>
    </React.Fragment>
  )
}

HeaderVersatileTemplate.propTypes = {
  groupImage: PropTypes.string,
  imageAlt: PropTypes.string,
  heading: PropTypes.string,
  backupHeading: PropTypes.string,
  enableH1: PropTypes.bool,
  headingSize: PropTypes.string,
  hideMediaMobile: PropTypes.bool,
  displaySubHeading: PropTypes.bool,
  subHeading: PropTypes.string,
  ctaLabel: PropTypes.string,
  displayCta: PropTypes.bool,
  ctaLabel2: PropTypes.string,
  displayCta2: PropTypes.bool,
  clickthroughUrl: PropTypes.string,
  clickthroughUrl2: PropTypes.string,
  backgroundColor: PropTypes.string,
  mediaType: PropTypes.string,
  mediaTitle: PropTypes.string,
  youtubeId: PropTypes.string,
  zipcodeField: PropTypes.bool,
  zipcodeFieldLabel: PropTypes.string,
  zipcodeCtaLabel: PropTypes.string,
  useNewFonts: PropTypes.bool,
}

const HeaderVersatile = ({ moduleData }) => {
  return <HeaderVersatileTemplate {...moduleData} />
}

HeaderVersatile.propTypes = {
  moduleData: PropTypes.shape(HeaderVersatileTemplate.propTypes),
}

export default HeaderVersatile
